import { render, staticRenderFns } from "./FavouriteLotsShortList.vue?vue&type=template&id=4ad2b533&scoped=true"
import script from "./FavouriteLotsShortList.vue?vue&type=script&lang=js"
export * from "./FavouriteLotsShortList.vue?vue&type=script&lang=js"
import style0 from "./FavouriteLotsShortList.vue?vue&type=style&index=0&id=4ad2b533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2b533",
  null
  
)

export default component.exports